import React, { useState, useEffect, useContext } from 'react'
import BreakingNewsComponent from '../../components/BreakingNewsComponent';
import BreakingNewsForm from '../../components/BreakingNewsForm';
import Table from '../../components/Table';
import { AuthContext } from '../../context/AuthContext';
import { api } from '../../api/axios';
import { tableDateFormate } from '../../utils/dateHelper';
import { Eye, EyeOff, Trash, Pen } from 'lucide-react';
import { toast } from 'react-toastify';
import PaginationBar from '../../components/PaginationBar';

const PAGE_SIZE = 20;

const tableHeadingdata = [
    '#',
    'Title',
    'Date',
    'Action'
]


export default function BreakingNews() {

    const { loading } = useContext(AuthContext);
    const [breakingNewsData, setBreakingNewsData] = useState([]);
    const [page, setPage] = useState(1);

    useEffect(() => {
        handelGetData();

    }, [loading])

    const handelGetData = async () => {
        try {
            const response = await api.get('/breakingnews');
            setBreakingNewsData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handelChangeVisibilityOffBreakingNews = async (id, isActive) => {
        try {
            const resposns = await api.patch(`/breakingnews/active/${id}`, { isActive: !isActive })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Breaking News Visibility Changed Successfully")
            }
        } catch (error) {
            toast.error("Breaking News Visibility Changed Error")
            console.log(error);
        }
    }

    const handelDeleteBreakingNews = async (id) => {
        if (!window.confirm('Delete this breaking news? This cannot be undone.')) return;
        try {
            const resposns = await api.delete(`/breakingnews/${id}`)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Breaking News Deleted Successfully")
            }

        } catch (error) {
            toast.error("Breaking News Delete Error")
            console.log(error);
        }
    }

    return (
        <>
            <BreakingNewsComponent >
                <BreakingNewsForm />

                <Table tableHeadingdata={tableHeadingdata}>
                    {
                        breakingNewsData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((item, index) => (
                            <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={index}>
                                <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                    {(page - 1) * PAGE_SIZE + index + 1}
                                </th>
                                <td className="px-6 py-4 font-medium whitespace-nowrap">
                                    {item.title}
                                </td>
                                <td className="px-6 py-4">
                                    {tableDateFormate(item.createdAt)}
                                </td>
                                <td className="px-6 py-4 text-right flex gap-3 justify-center">
                                    <button
                                        onClick={() => handelChangeVisibilityOffBreakingNews(item._id, item.isActive)}
                                        className="font-medium text-gray-400 dark:text-gray-400 dark:hover:text-gray-800 hover:text-gray-800">
                                        {item.isActive ? <Eye /> : <EyeOff />}
                                    </button>
                                    <button
                                        onClick={() => handelDeleteBreakingNews(item._id)}
                                        className="font-medium text-red-300 dark:text-red-300 dark:hover:text-red-600 hover:text-red-600">
                                        <Trash />
                                    </button>
                                </td>
                            </tr>
                        ))
                    }
                </Table>

                <div className="mt-4">
                    <PaginationBar
                        totalItems={breakingNewsData.length}
                        page={page}
                        pageSize={PAGE_SIZE}
                        onChange={setPage}
                    />
                </div>
            </BreakingNewsComponent>

        </>
    )
}
